import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Container } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import { jwtDecode } from "jwt-decode";
// import { CiCalendarDate } from "react-icons/ci";
import {
  FaCalendarAlt,
  FaCaretDown,
  FaCrown,
  FaFacebookF,
  FaHome,
  FaInstagram,
  FaLinkedinIn,
  FaPhone,
  FaPhoneAlt,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { MdOutlineDoubleArrow } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
// import BookingModalForm from "./BookingModalForm";
import { RiMenu3Fill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";

// import Logo from './logo.png'

const Navbars = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [active, setIsActive] = useState(false);

  const [prevScrollY, setPrevScrollY] = useState(0);
  const [showNavbar, setShowNavbar] = useState(true);

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
    setIsActive(!active);
  };

  const handleScroll = () => {
    setIsSticky(window.scrollY > 40);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > prevScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }

      if (window.scrollY > 40) {
        setIsSticky(true); // Navbar is sticky after scrolling 40px
      } else {
        setIsSticky(false); // Navbar is not sticky at the top
      }
      setPrevScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollY]);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [isAuthenticated, setIsAuthenticated] = useState(false); // New state to track authentication
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  useEffect(() => {
    const checkAuthStatus = () => {
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000;

          if (decodedToken.exp > currentTime) {
            setIsAuthenticated(true); // Token is valid, user is authenticated
          } else {
            localStorage.removeItem("token");
            setIsAuthenticated(false);
            // navigate("/signin");
          }
        } catch (error) {
          localStorage.removeItem("token");
          setIsAuthenticated(false);
          // navigate("/signin");
        }
      }
    };

    checkAuthStatus();
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    navigate("/signin");
  };

  return (
    <>
      {/* <div className="banner-offer-cont">
        <FaCrown style={{ marginRight: "8px", marginTop: "-3px" }} size={19} />
        <span style={{fontSize:"larger", fontWeight:"600"}}>Super Offer</span> - Save 50% on all the packages. Limited time offer for
        limited number of{" "}
        <Link to="/signup" className="banner-offer-ancher">
          SignUp
        </Link>
        . Hurry Up!
      </div> */}
      <div id="home">
        <header
          className={`container-fluidss dog ${showNavbar ? "show" : "hide"} ${
            isSticky ? "sticky" : ""
          }`}
        >
          <div className="">
            <div className="row">
              <div className="cheader">
                <div className="hheaader">
                  <div className="navbar-logoVDNI">
                    <Link to="/" className="comp_logo">
                      <img
                        title=""
                        src="/Images/logo-vdni.png"
                        className="img-fluid logo"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className={`navigation ${isOpen ? "active" : ""}`}>
                    <ul>
                      {/* Menu items */}
                      <li className="dropdown">
                        <Link to="/sell-your-music" title="Sell Your Music">
                          Home
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link
                          className="service_text_clr"
                          to="/music-distribution-services"
                          title="Service"
                        >
                          About Us
                        </Link>
                        {/* <ul className="dropdown-menu">
                          <li onClick={() => setIsOpen(false)}>
                            <Link
                              title="Rights Management"
                              to="/music-right-management"
                            >
                              Rights Management
                            </Link>
                          </li>
                          <li onClick={() => setIsOpen(false)}>
                            <Link
                              title="YouTube Monetization"
                              to="/youtube-monetization"
                            >
                              YouTube Monetization
                            </Link>
                          </li>
                          <li onClick={() => setIsOpen(false)}>
                            <Link
                              title="Music Publishing"
                              to="/music-publishing"
                            >
                              Music Publishing
                            </Link>
                          </li>
                          <li onClick={() => setIsOpen(false)}>
                            <Link
                              title="Digital Distribution"
                              to="/digital-distribution"
                            >
                              Digital Distribution
                            </Link>
                          </li>
                        </ul> */}
                      </li>
                      <li className="dropdown" onClick={() => setIsOpen(false)}>
                        <Link title="Pricing" to="/music-distribution-pricing">
                          Our Service
                        </Link>
                      </li>
                      <li onClick={() => setIsOpen(false)}>
                        <Link
                          title="Music Distribution"
                          to="/music-distribution"
                        >
                          Our Team
                        </Link>
                      </li>
                      <li className="dropdown" onClick={() => setIsOpen(false)}>
                        <Link title="Pricing" to="/music-stores">
                          Our Client
                        </Link>
                      </li>
                      <li onClick={() => setIsOpen(false)}>
                        <Link title="Support" to="/contact-us">
                          Contact US
                        </Link>
                      </li>
                      <li className="navbar_phone_number phone-number-bttn">
                        <Link title="Contact Us" to="tel:+918084187424">
                          <FaPhoneAlt className="navbar-fonts" size={20} />
                          <div className="txt phone-number-fonts">
                            +91 7492047656
                          </div>
                        </Link>
                      </li>
                      <li className="socialss" style={{ marginTop: "10px" }}>
                        <div className="sixstyle__FooterSection-sc-915j0m-4 hLuZHF">
                          <div className="SocialShare__Wrapper-h9wts-0 qJGGM social_profiles">
                            <div className="SocialShare__Item-h9wts-1 fvcUgI social_profile_item">
                              <Link
                                // to="https://www.instagram.com/finaltakefilmproduction/"
                                target="_blank"
                                onClick={() => setIsOpen(false)}
                              >
                                <FaInstagram />
                              </Link>
                            </div>
                            <div className="SocialShare__Item-h9wts-1 fvcUgI social_profile_item">
                              <Link
                                // to="https://www.x.com/Finaltakeindia"
                                target="_blank"
                                onClick={() => setIsOpen(false)}
                              >
                                <FaTwitter />
                              </Link>
                            </div>
                            <div className="SocialShare__Item-h9wts-1 fvcUgI social_profile_item">
                              <Link
                                // to="https://www.facebook.com/finaltakefilmproduction"
                                target="_blank"
                                onClick={() => setIsOpen(false)}
                              >
                                <FaFacebookF />
                              </Link>
                            </div>
                            <div className="SocialShare__Item-h9wts-1 fvcUgI social_profile_item">
                              <Link
                                // tp="http://www.linkedin.com/in/finaltakefilmproduction"
                                target="_blank"
                                onClick={() => setIsOpen(false)}
                              >
                                <FaLinkedinIn />
                              </Link>
                            </div>
                            <div className="SocialShare__Item-h9wts-1 fvcUgI social_profile_item">
                              <Link
                                to="https://www.maps.app.goo.gl/4ftPgrEtrWh5cbDw8"
                                target="_blank"
                                onClick={() => setIsOpen(false)}
                              >
                                <FaLocationDot />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="spaceetc"
                  style={{ display: "flex", gap: "20px" }}
                >
                  {isAuthenticated ? (
                    <>
                      <div className="button-container_buttonContainer__YRgZl button-container_center__H3vVZ">
                        <Link
                          className="button_button__MFmXH button_color__bLscP"
                          to="/artist/dashboard"
                        >
                          Dashboard
                        </Link>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="button-container_buttonContainer__YRgZl button-container_center__H3vVZ">
                        <Link
                          className="button_button__MFmXH button_color-login"
                          to="/signin"
                          style={{ color: "#000" }}
                          target="_blank"
                        >
                          Login
                        </Link>
                      </div>
                      <div className="button-container_buttonContainer__YRgZl button-container_center__H3vVZ">
                        <Link
                          className="button_button__MFmXH button_color__bLscP"
                          to="/signup"
                          target="_blank"
                        >
                          Signup
                        </Link>
                      </div>
                    </>
                  )}
                </div>

                <div
                  className={`menu menu_btn hamburger ${isOpen ? "open" : ""}`}
                  onClick={handleMenuClick}
                >
                  <RiMenu3Fill className="ic" size={30} color="#d70d57" />
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </>
  );
};

export default Navbars;
